package com.example.mystybag.appCore.views.pages

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import com.example.mystybag.appCore.logic.pages.CategoryBagsListViewModel
import com.example.mystybag.common.extensions.scrollEdgeFade
import com.example.mystybag.common.ui.components.custom.ShimmerAsyncImage
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.views.UIView
import com.example.mystybag.core.expected.sharedString
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.views.AppTheme

@Composable
fun CategoryBagsListView(viewModel: CategoryBagsListViewModel) {
    val uiState by viewModel.uiState.subscribeAsState()
    
    UIView(viewModel = viewModel) {
        Box(modifier = Modifier.fillMaxSize()) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(p16)
                    .widthIn(max = 412.dp)
                    .align(Alignment.TopCenter)
            ) {
                if (uiState.bags.isEmpty()) {
                    Box(
                        modifier = Modifier.fillMaxSize(),
                        contentAlignment = Alignment.Center
                    ) {
                        Texts.BodyMedium(text = sharedString(SR.strings.no_bags_found))
                    }
                } else {
                    LazyColumn(
                        modifier = Modifier
                            .fillMaxWidth()
                            .scrollEdgeFade(),
                        verticalArrangement = Arrangement.spacedBy(p12)
                    ) {
                        items(uiState.bags, key = { it.id }) { bag ->
                            CategoryBagCard(
                                bag = bag,
                                onClick = { viewModel.onBagClick(bag) }
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun CategoryBagCard(
    bag: com.example.mystybag.sharedmodels.project.responseModels.HomeTopPickUiModel,
    onClick: () -> Unit
) {
    Card(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick),
        shape = RoundedCornerShape(p12),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(
            modifier = Modifier.fillMaxWidth()
        ) {
            // Bag image
            ShimmerAsyncImage(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(200.dp),
                link = bag.locationCoverUrl,
                placeholder = null,
                useOriginalSize = false,
                contentScale = ContentScale.Crop
            )
            
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(p16)
            ) {
                // Title
                Texts.TitleMedium(text = bag.title)
                
                Spacer(modifier = Modifier.height(p8))
                
                // Subtitle (business category)
                if (bag.subtitle.isNotEmpty()) {
                    Texts.LabelSmall(
                        text = bag.subtitle,
                        color = AppTheme.current.colors.onSurfaceVariant
                    )
                    Spacer(modifier = Modifier.height(p8))
                }
                
                // Price
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(p8),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        if (bag.oldPrice.isNotEmpty()) {
                            Texts.StrikeThroughText(
                                text = bag.oldPrice,
                                style = AppTheme.current.typography.labelMedium
                            )
                        }
                        Texts.LabelLarge(
                            text = bag.newPrice,
                            color = AppTheme.current.colors.primary
                        )
                    }
                    
                    // Distance
                    if (bag.distance.isNotEmpty()) {
                        Texts.LabelSmall(text = bag.distance)
                    }
                }
                
                Spacer(modifier = Modifier.height(p8))
                
                // Collection info
                if (bag.collectInfo.isNotEmpty()) {
                    Texts.BodySmall(text = bag.collectInfo)
                }
            }
        }
    }
}
